import { Store, configureStore } from "@reduxjs/toolkit";
import React from "react";
import { Provider } from "react-redux";

import { reverse } from "@reactivated";

import {
    IProductID,
    IWebPageURL,
    isoWebPageURL,
} from "../../../models/nominals";
import { urls } from "../../../utils/urls";
import { Configurator } from "../../configurator/containers/Configurator";
import { getDefaultConfiguratorOptionSet } from "../../configurator/utils";
import { middleware } from "../../middleware";
import { coreReducers } from "../../reducers";
import { IRootState } from "../../reducers.interfaces";

interface IMicroConfiguratorProps {
    rootProductIDs: IProductID[];
    basketLink?: IWebPageURL;
    financingLink?: IWebPageURL;
}

// NOTE: This is a temporary solution to the MicroConfigurator functionality,
//       written by @cweber and @zlebar

// TODO(ssr, LEVEL 3 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 3/10 due to simple render logic with Redux store initialization that could be handled with useMemo.
export class MicroConfiguratorRowContent extends React.Component<
    IMicroConfiguratorProps,
    Record<string, never>
> {
    private microStore: Store<IRootState> | null = null;

    render(): React.JSX.Element {
        if (!this.microStore) {
            this.microStore = configureStore({
                reducer: coreReducers,
                middleware: (getDefaultMiddleware) => {
                    return getDefaultMiddleware().concat(middleware);
                },
                devTools: {
                    name: `MicroConfigurator-${this.props.rootProductIDs}`,
                },
            });
        }
        return (
            <Provider store={this.microStore}>
                <Configurator
                    optionSet={{
                        ...getDefaultConfiguratorOptionSet(),
                        product_ids: this.props.rootProductIDs,
                    }}
                    enableHistoryInteraction={false}
                    financingLink={
                        this.props.financingLink ||
                        urls.pageURL("finance-link") ||
                        urls.pageURL("home")
                    }
                    basketLink={
                        this.props.basketLink ||
                        isoWebPageURL.wrap(reverse("basket:summary"))
                    }
                    favoritesLink={isoWebPageURL.wrap(
                        reverse("basket:summary"),
                    )}
                    configureGiftsLink={isoWebPageURL.wrap(
                        reverse("basket:configure-gifts"),
                    )}
                    configType={"micro"}
                    buttonColor={"primary-congress-blue"}
                    showShippingLead={false}
                    showFeelScale={true}
                    showPreTitle={false}
                    showVariantCallout={false}
                    strikeThroughMSRP={false}
                    actualPriceStyle={""}
                    boxHeaderContent={""}
                    topBadgeContent={""}
                    showFinancingModal={true}
                />
            </Provider>
        );
    }
}
